import { IFacility } from '../../models/facility';
import { website } from '../../resources/website';
import ApiService from '../../services/api_service';

export const BASE_DATA_LOADING = 'WEBSITE/BASE_DATA_LOADING';
export const BASE_DATA_LOAD_SUCCESS = 'WEBSITE/BASE_DATA_LOAD_SUCCESS';
export const BASE_DATA_LOAD_FAILED = 'WEBSITE/BASE_DATA_LOAD_FAILED';
export function loadBaseData() {
  return (dispatch) => {
    dispatch({ type: BASE_DATA_LOADING });
    return website(new ApiService(process.env.SITE_API_URL ?? (location.origin + '/api-site')))
      .getBaseData(process.env.HOSTNAME ?? location.hostname)
      .then((result: IFacility) => {
        dispatch({ type: BASE_DATA_LOAD_SUCCESS, data: result });
        return result;
      })
      .catch((err) => {
        dispatch({ type: BASE_DATA_LOAD_FAILED, error: err });
        throw err;
      });
  };
}
